/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Footnote_EmbeddingInputs */



/**
* | output |
* | --- |
* | "**** There is a flat rate cost of $2.00 per file + $0.40/GB for closed caption embedding." |
*
* @param {Signup_Footnote_EmbeddingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_footnote_embedding = /** @type {((inputs?: Signup_Footnote_EmbeddingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Footnote_EmbeddingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("**** There is a flat rate cost of $2.00 per file + $0.40/GB for closed caption embedding.")
	if (locale === "de") return /** @type {LocalizedString} */ ("**** There is a flat rate cost of $2.00 per file + $0.40/GB for closed caption embedding.")
	if (locale === "it") return /** @type {LocalizedString} */ ("**** There is a flat rate cost of $2.00 per file + $0.40/GB for closed caption embedding.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("**** There is a flat rate cost of $2.00 per file + $0.40/GB for closed caption embedding.")
	if (locale === "es") return /** @type {LocalizedString} */ ("**** There is a flat rate cost of $2.00 per file + $0.40/GB for closed caption embedding.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("**** There is a flat rate cost of $2.00 per file + $0.40/GB for closed caption embedding.")
	if (locale === "ja") return /** @type {LocalizedString} */ ("**** There is a flat rate cost of $2.00 per file + $0.40/GB for closed caption embedding.")
	if (locale === "hi") return /** @type {LocalizedString} */ ("**** There is a flat rate cost of $2.00 per file + $0.40/GB for closed caption embedding.")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("**** There is a flat rate cost of $2.00 per file + $0.40/GB for closed caption embedding.")
	return /** @type {LocalizedString} */ ("**** There is a flat rate cost of $2.00 per file + $0.40/GB for closed caption embedding.")
});